<template>
    <section>
        <b-modal v-model="open" :title="$t('message.edit') + ' - ' + (this.item ? this.item.serial_number : '')" ref="modal" id="modal-homebase">
            <vue-form-generator ref="editHomebase" :schema="schema" :model="model" :options="formOptions" @validated="onValidated"></vue-form-generator>
            <template #footer>
                <b-btn @click="open=false">{{$t('message.cancel')}}</b-btn>
                <b-btn @click="validate" type="primary">{{$t('message.edit')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    import VueFormGenerator from 'vue-form-generator'
    import { mapState, mapActions } from 'vuex'
    import mixins from '../../../modules/mixins'

    export default {
        name: 'EditHomebase',
        mixins: [mixins],
        data () {
            return {
                open: false,
                isValid: false,
                item: null,
                model: {
                    building: null,
                    name: null
                },
                schema: {
                    fields: [{
                        type: 'select',
                        label: this.$t('message.building'),
                        i18n: {
                            label: 'message.building'
                        },
                        model: 'building',
                        required: true,
                        values: []
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.name'),
                        i18n: {
                            label: 'message.name'
                        },
                        model: 'name',
                        featured: true,
                        required: true,
                        validator: VueFormGenerator.validators.string
                    }]
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: true
                }
            }
        },
        watch: {
            buildings (values) {
                if (!values) {
                    return
                }

                this.schema.fields[0].values = values
                this.model.building = this.item.building.id
            },
            result (value) {
                if (value) {
                    this.item.name = this.model.name
                    this.item.building.name = this.getBuildingName(this.model.building)
                    this.open = false
                    // this.item = null
                }
            }
        },
        computed: {
            ...mapState({
                entities: state => state.entity
            }),
            buildings () {
                return this.entities.buildings.buildings
            },
            result () {
                return this.entities.homebase.result
            }
        },
        methods: {
            ...mapActions('entity', {
                getBuildings: 'getBuildings',
                editHomebase: 'editHomebase'
            }),
            onValidated  (isValid) {
                this.isValid = isValid
            },
            validate () {
                this.$refs.editHomebase.validate()
                if (this.isValid) {
                    this.editHomebase({homebase: this.item.id, data: this.model})
                }
            },
            getBuildingName (id) {
                for (let b of this.buildings) {
                    if (b.id === id) {
                        return b.name
                    }
                }
            },
            show (item) {
                this.getBuildings(this.activeOrganization.id)
                this.open = true
                this.item = item
                this.model.name = item.name
            }
        }
    }
</script>

<style scoped>

</style>